import { render } from "./accountInfoWsDetail.vue?vue&type=template&id=be1f19f4&scoped=true"
import script from "./accountInfoWsDetail.vue?vue&type=script&lang=js"
export * from "./accountInfoWsDetail.vue?vue&type=script&lang=js"

import "./accountInfoWsDetail.vue?vue&type=style&index=0&id=be1f19f4&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1f19f4"]])

export default __exports__